import React, { useState, useEffect } from 'react'
import { Form, Input, Select, Button, message, Checkbox, Tooltip } from 'antd'
import { CaretDownOutlined } from '@ant-design/icons'
import { Link, useHistory } from "react-router-dom"
import FullScreenModal from '../FullHeightModal'
import './index.css'
import * as com from '../../../Common'
import { useSelector, useDispatch } from 'react-redux'
import { checkAccess } from "../../../Auth"
import { UR_Owner, UR_LoanOfficer } from "../../../State"
import { track, flushThenLeave } from 'statsig'
import { STATSIG } from 'statsig/events'

const LoanBorrowerPopUp = ({ type, open, onClose, submit, skipBorrower, getInfo }) => {
    const [form] = Form.useForm()
    const history = useHistory()
    const [isSuccess, setIsSuccess] = useState(false)
    const [currentData, setCurrentData] = useState({})
    const [currentFormData, setCurrentFormData] = useState({})

    const [isAlready, setIsAlready] = useState(false)
    const [isAlreadyByOther, setIsAlreadyByOther] = useState(false)
    const [borrowId, setBorrowId] = useState('')
    const [loanId, setLoanId] = useState(false)
    const [CurrentInfo, setCurrentInfo] = useState({})
    const [loading, setLoading] = useState(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState(true)
    const [notifyBorrowerCreation, setNotifyBorrowerCreation] = useState(false)
    const [notifyLoanCreation, setNotifyLoanCreation] = useState(false)
    const [applicationLink, setApplicationLink] = useState('')
    const canShowApplicationLink = checkAccess([UR_Owner, UR_LoanOfficer])
    useEffect(() => {

        form.resetFields()
        setIsSuccess(false)
        setIsAlready(false)
        setIsAlreadyByOther(false)
    }, [open])
    useEffect(() => {
        if (!canShowApplicationLink || applicationLink) return
        const token = sessionStorage.getItem("ZeitroA")
        if (!token) return
        fetch("/los/getappurl", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            },
        }).then((response) => {
            if (response.status !== 200) return
            response.json().then((r) => {
                if (r && r.AppUrl) {
                    const link = `${r.AppUrl}/services/preapp?customerid=${com.getCustomerId()}&loid=${com.getLoId()}`
                    setApplicationLink(link)
                }
            })
        }).catch(() => {})
    }, [canShowApplicationLink, applicationLink])
    const copyApplicationLink = () => {
        if (!applicationLink) {
            message.error('Application link is not available yet.')
            return
        }
        navigator.clipboard.writeText(applicationLink)
            .then(() => {
                message.success('Application link copied!')
            })
            .catch(() => {
                message.error('Failed to copy application link.')
            })
    }
    useEffect(async () => {


        if (getInfo) {
            // console.log(location.);
            const info = sessionStorage.getItem('currentBorrower')
            const data = JSON.parse(info)



            form.setFieldsValue({

                firstname: data.name.split(' ')[0],
                lastname: data.name.split(' ')[1],
                email: data.email,
                purpose: data.purpose
            })
            checkFormComplete()
        }
    }, [getInfo])
    const checkFormComplete = () => {
        if (type !== 'borrower') {
            const values = form.getFieldsValue()
            const requiredFields = ['firstname', 'lastname', 'email', 'purpose']
            const allFieldsFilled = requiredFields.every(field => values[field])
            setIsButtonDisabled(!allFieldsFilled)
        }
    }
    const LoanForm = () => {
        return <div style={{ margin: 'auto', paddingBottom: '75px'}}>
            <div className='loadTitle'>
                {type === 'borrower' ? 'Add a borrower' : ' Create new loan'}
            </div>
            {type === 'borrower' ? <></> : <div className='loadInformation'>Add borrower’s information</div>
            }
            <Form
                form={form}
                className='loan-form'
                layout="vertical"
                onFieldsChange={checkFormComplete}
                requiredMark={false}
                onFinish={(value) => {
                    setCurrentFormData(value)
                    if (type == 'borrower') {

                        createBorrow(value)
                    } else {
                        createNewApplication(value)
                    }
                }}
                style={{ maxWidth: 320, margin: " auto", marginTop: 26 }}
            >
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: "First name  is required "
                        },
                    ]}
                    style={{ color: 'red' }} label="First name" name="firstname">
                    <Input className='loan-borrower-input' placeholder="Enter borrower’s first name" />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: "Last name is required "
                    },
                ]} label="Last name" name='lastname'
                >
                    <Input className='loan-borrower-input' placeholder='Enter borrower’s last name' />
                </Form.Item>
                {
                    type == 'borrower' ? null :
                        <Form.Item rules={[
                            {
                                required: true,
                                message: "Loan purpose  is required "
                            },
                        ]} label="Loan purpose" name='purpose'>
                            <Select suffixIcon={<CaretDownOutlined style={{ color: '#6E6E70' }} />} className='loan-borrower-select' placeholder='Choose loan purpose'>
                                <Select.Option value="purchase">Purchase</Select.Option>
                                <Select.Option value="refinance">Refinance</Select.Option>
                                <Select.Option value="cashoutrefinance">Cash out refinance</Select.Option>
                            </Select>
                        </Form.Item>
                }

                <Form.Item label="Email" name='email'

                    rules={[

                        {
                            required: 'true',
                            type: 'email',
                            message: "Email  is required "

                        },

                    ]}
                >
                    <Input className='loan-borrower-input' placeholder='Enter borrower’s email address' />
                </Form.Item>
                {/* {type == 'borrower' ? null : <div className='loadInformation' style={{ marginTop: '-18px' }}>
                    An invitation to complete a loan application will be sent to the borrower's email after creating the loan.
                </div>} */}
                <Checkbox rootClassName='loan-borrower-checkbox' 
                    onChange={() => {
                        if (type == 'borrower') {
                            setNotifyBorrowerCreation(!notifyBorrowerCreation)
                        } else {
                            setNotifyLoanCreation(!notifyLoanCreation)
                        }
                    }}
                    checked={type == 'borrower' ? notifyBorrowerCreation : notifyLoanCreation}
                >
                    Invite borrower to complete the application
                </Checkbox>
                <Button
                    loading={loading}
                    htmlType='submit'
                    className='loan-borrower-modal-btn'
                    disabled={type != 'borrower' && isButtonDisabled}
                    style={{
                        height: 44,
                        width: '100%',
                        color: '#FCFCFC',
                        fontFamily: 'Inter',
                        fontSize: '16px',
                        fontWeight: '600',
                        marginTop: "24px"
                    }}
                    type='primary'>{

                        type == 'borrower' ? 'Add borrower' : 'Create'
                    } </Button>
                {/* {type == 'borrower' ? <div className='loadInformation' style={{ marginTop: '10px' }}>
                    By clicking the button, an invitation to complete the application will be sent to your borrower's email address. You can always return to the "Borrowers" page to check this borrower's information.
                </div> : null} */}

            </Form>
        </div >

    }
    const createNewApplication = async (data) => {

        let token = sessionStorage.getItem("ZeitroA")
        let local = window.location.hostname === "localhost"
        let js = {
            email: data.email.toLowerCase(),
            firstName: data.firstname,
            lastName: data.lastname,
            purpose: data.purpose,
            notifyLoanCreation: notifyLoanCreation,
        }

        const savedUserInfo = JSON.parse(sessionStorage.getItem('statsig_user_info'));

        fetch('/los/createapplicationbylo', {
            method: 'POST',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                userEmail: savedUserInfo.email
            },
            body: JSON.stringify(js)
        }).then(
            response => {
                if (response.status !== 200) {
                    alert("Please add a borrower")
                    return
                }
                response.json().then(js => {
                    if (js.Status !== "OK") {
                        alert("Looks like there was a problem, please try again later.")
                    } else {
                        if (type == 'borrower') {
                            if (window.location.pathname.includes('/app/borrowers')) {
                                track(STATSIG.BORROWERS.BORROWER_INSERT, js.Token)
                            }
                        } else if (window.location.pathname.includes('active-loans')) {
                            track(STATSIG.LOANS.LOAN_INSERT, 'create_manually', {
                                type: 'insert',
                                method: 'create_manually',
                            })
                        }
                        submit()
                        setIsSuccess(true)
                        setCurrentData(js)
                        // this.setState({
                        //     openLoanPopup: false
                        // })
                        // setNewAppLoanID(js.Token)
                        // getBorrowerLoans()
                        // setIsNewAppModalStatus(2)

                    }

                })
            }
        ).catch((err) => {
            console.log('Fetch Error :', err)
            if (!local)
                window.grecaptcha.reset()
        })
    }
    const successContent = () => {
        const alreadyOwnedByOtherOfficer = type == 'borrower' && isAlreadyByOther
        const alreadyOwnedBySelf = type == 'borrower' && isAlready && !isAlreadyByOther

        return (
            <div style={{ textAlign: 'center', marginTop: '100px' }}>
                <img src='/images/loanSuccess.svg'></img>
                <div className='loadTitle' style={{
                    marginTop: 30
                }}>
                    {alreadyOwnedByOtherOfficer
                        ? 'This borrower is already assigned to another loan officer'
                        : alreadyOwnedBySelf
                            ? 'This borrower has already been added'
                            : type == 'borrower'
                                ? 'Borrower added successfully'
                                : "Loan appliation created successfully"}
                </div>
                <div className='loadInformation' style={{
                    width: '50%', margin: "auto", marginTop: '10px'
                }}>
                    {
                        alreadyOwnedByOtherOfficer
                            ? 'Double-check the email address. If it\'s correct, contact your admin to request access to this borrower.'
                            : alreadyOwnedBySelf
                                ? 'Use the button below to start the application.'
                                : type == 'borrower'
                                    ? (
                                        notifyBorrowerCreation
                                            ? 'The invitation email has been successfully sent. While waiting for the borrower to complete their information, you may proceed to start the application process by clicking the button below.'
                                            : 'Borrower added successfully. You may proceed to start the application process by clicking the button below.'
                                    )
                                    : (
                                        notifyLoanCreation
                                            ? "An invitation to fill out the application information has also been sent to the borrower's email address."
                                            : "Loan application created successfully. You may proceed to start the application process by clicking the button below."
                                    )
                    }
                </div>
                {alreadyOwnedByOtherOfficer ? (
                    <Button
                        onClick={() => {
                            setIsSuccess(false)
                            setIsAlready(false)
                            setIsAlreadyByOther(false)
                            setLoading(false)
                            onClose()
                        }}
                        style={{
                            height: 44,
                            width: '50%',
                            color: '#FCFCFC',
                            fontFamily: 'Inter',
                            fontSize: '16px',
                            fontWeight: '600',
                            marginTop: "24px",
                            marginBottom: 15
                        }}
                        type='primary'
                    >
                        OK
                    </Button>
                ) : (
                <>
                <Button
                    onClick={() => {
                        if (type == 'borrower') {
                            if (loanId == '') {
                                let token = sessionStorage.getItem("ZeitroA")
                                let local = window.location.hostname === "localhost"
                                let js = {
                                    email: currentFormData.email.toLowerCase(),
                                    firstName: currentFormData.firstname,
                                    lastName: currentFormData.lastname,
                                    purpose: "purchase",   //since create borrower does not ask user for purpose, default purpose to purchase
                                    notifyLoanCreation: notifyBorrowerCreation,
                                }

                                const savedUserInfo = JSON.parse(sessionStorage.getItem('statsig_user_info'));

                                fetch('/los/createapplicationbylo', {
                                    method: 'POST',
                                    headers: {
                                        Authorization: "Bearer " + token,
                                        Cache: "no-cache",
                                        userEmail: savedUserInfo.email
                                    },
                                    body: JSON.stringify(js)
                                }).then(
                                    response => {
                                        if (response.status !== 200) {
                                            alert("Looks like there was a problem, please try again later or contact Zeitro support.")
                                            return
                                        }
                                        response.json().then(js => {
                                            if (js.Status !== "OK") {
                                                alert("Looks like there was a problem, please try again later.")
                                            } else {
                                                message.success('created successfully')
                                                // submit()
                                                sessionStorage.setItem("edit", "false")
                                                sessionStorage.setItem("state", "{}")
                                                sessionStorage.setItem("originalstate", "{}")
                                                sessionStorage.setItem("borrowermenu", "loanSummary")
                                                // this.props.history.push("/app/borrower/" + currentData?.Token)
                                                sessionStorage.setItem("borrowermenu", '1003View')
                                                history.push('/app/active-loans')
                                                history.push(`/app/borrower/${js?.Token}`)
                                                // window.open(`/app/borrower/${js?.Token}`, "_self")
                                                // window.open(`/app/borrower/${js?.Token}`, "_self")

                                                // onClose()


                                            }

                                        })
                                    }
                                )
                            } else {
                                sessionStorage.setItem("borrowermenu", '1003View')
                                history.push("/app/borrower/" + loanId)

                            }

                            onClose()

                        } else {
                            if (window.location.pathname.includes('active-loans')) {
                                track(STATSIG.LOANS.LOAN_OPEN, currentData?.Token, {
                                    source: 'popup',
                                    target_link: `/app/borrower/${currentData?.Token}`,
                                })
                            }
                            sessionStorage.setItem("edit", "false")
                            sessionStorage.setItem("state", "{}")
                            sessionStorage.setItem("originalstate", "{}")
                            sessionStorage.setItem("borrowermenu", '1003View')
                            onClose()
                            // history.push("/app/borrower/" + currentData?.Token)
                            void flushThenLeave(() => {
                                window.location.href = "/app/borrower/" + currentData?.Token
                            })
                        }

                    }}
                    style={{
                        height: 44,
                        width: '50%',
                        color: '#FCFCFC',
                        fontFamily: 'Inter',
                        fontSize: '16px',
                        fontWeight: '600',
                        marginTop: "24px",
                        marginBottom: 15

                    }}
                    type='primary'>
                    {type == 'borrower' ? "Start borrower's loan application" : ' Go to this application'}
                </Button>
                {/* Copy the invitation link for the borrower */}
                <div
                >

                    <Link style={{ textDecoration: 'underline', marginTop: "12px" }} onClick={() => {

                        if (type == 'borrower') {
                            submit()
                            onClose()
                            history.push(`/app/borrowers/${borrowId}`)
                            window.location.reload()

                            // skipBorrower({
                            //     email: currentFormData.email,
                            //     token: currentData.Token
                            // })


                        }

                    }}>{
                            type == 'borrower' ? "View this borrower's Information page" : ''
                        }</Link>
                </div>
                {canShowApplicationLink && (
                    <div className="share-application-link">
                        <div className="share-application-link-label">
                            Share application link with borrower
                        </div>
                        <div className="share-application-link-row">
                            <Tooltip title={applicationLink || ''} placement="top">
                                <div className="share-application-link-text">
                                    {applicationLink || 'Loading link...'}
                                </div>
                            </Tooltip>
                            <img
                                className="share-application-link-copy"
                                src="/images/copy-blue.svg"
                                alt="Copy"
                                onClick={copyApplicationLink}
                            />
                        </div>
                    </div>
                )}
                </>
                )}
            </div >
        )


    }

    const createBorrow = async (data) => {
        setLoading(true)
        let token = sessionStorage.getItem("ZeitroA")
        let local = window.location.hostname === "localhost"

        let tosend =
            JSON.stringify({
                email: data.email.toLowerCase(),
                firstName: data.firstname,
                lastName: data.lastname,
                // purpose: data.purpose,
                notifyBorrowerCreation: notifyBorrowerCreation,
            })
        fetch('/los/signupborrowerbylo', {
            method: 'POST',
            body: tosend,
            headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer " + token,
            },
        }).then(
            async response => {
                // Backend returns 409 Conflict for "account validated" with a JSON body.
                // Always parse the body; do not bail on non-200 or the button stays loading.
                let js = {}
                try {
                    js = await response.json()
                } catch (_) {
                    js = {}
                }
                if (js.Status === "OK") {
                    if (window.location.pathname.includes('/app/borrowers')) {
                        track(STATSIG.BORROWERS.BORROWER_INSERT, js.LoanID)
                    }
                    setCurrentData(js)
                    setBorrowId(js.BorrowerID)
                    setLoanId(js.LoanID)
                    setIsSuccess(true)
                    setIsAlready(false)
                    setIsAlreadyByOther(false)
                    submit()
                    return
                }
                const errText = `${js.Error || js.Text || ""}`.toLowerCase()
                if (errText.includes("account added by another officer")) {
                    setBorrowId(js.BorrowerID || "")
                    setIsSuccess(true)
                    setIsAlready(true)
                    setIsAlreadyByOther(true)
                    return
                }
                if (
                    errText.includes("account already added")
                    || errText.includes("account validated")
                    || response.status === 409
                ) {
                    // Own LO (or legacy "account validated") — keep start-application flow.
                    setBorrowId(js.BorrowerID || "")
                    setIsSuccess(true)
                    setIsAlready(true)
                    setIsAlreadyByOther(false)
                    return
                }
                if (!local && window.grecaptcha) {
                    window.grecaptcha.reset()
                }
                message.error(js.Error || js.Text || "Looks like there was a problem, please try again later.")
                setIsAlready(false)
                setIsAlreadyByOther(false)
            }
        ).catch((err) => {
            console.log('Fetch Error :', err)
            if (!local && window.grecaptcha) {
                window.grecaptcha.reset()
            }
            message.error("Our servers are experiencing problems. Please check later.")
        }).finally(() => {
            setLoading(false)
        })
    }
    return (
        <FullScreenModal width='50%' open={open} onClose={() => {

            onClose()
            setIsSuccess(false)
            setIsAlready(false)
            setIsAlreadyByOther(false)
            setIsButtonDisabled(true)
        }} content={isSuccess ? successContent() : LoanForm()} title='' footer={null}>


        </FullScreenModal>
    )
}

export default LoanBorrowerPopUp
